import type { StaticLayerPayload } from "@config";
import { SideBySideLibrary } from "@library-combos/sideBySide";
import { Container } from "../Container";

export const SideBySide = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={{ default: SideBySideLibrary }} />
);
